import { ThemeEvents } from '@theme/events';

class DiscountPercentage extends HTMLElement {
  connectedCallback() {
    this.productCard = this.closest('product-card');
    this.productCard?.addEventListener(ThemeEvents.variantUpdate, this.updateDiscount);
    this.updateAccessibilityLabel();
  }

  disconnectedCallback() {
    this.productCard?.removeEventListener(ThemeEvents.variantUpdate, this.updateDiscount);
  }

  updateDiscount = (event) => {
    const variant = event.detail.resource;
    if (!variant) return;

    const price = Number(variant.price);
    const compareAtPrice = Number(variant.compare_at_price);
    const hasDiscount = compareAtPrice > price && compareAtPrice > 0;

    if (!hasDiscount) {
      this.hidden = true;
      this.removeAttribute('aria-label');
      return;
    }

    const discountPercent = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
    const value = this.querySelector('[ref="value"]');

    if (value) value.textContent = `-${discountPercent}%`;

    this.hidden = discountPercent <= 0;
    this.updateAccessibilityLabel(discountPercent);
  };

  updateAccessibilityLabel(discountPercent) {
    const value =
      discountPercent ??
      Number.parseInt(this.querySelector('[ref="value"]')?.textContent?.replace(/[^\d]/g, '') || '0', 10);

    if (value <= 0 || this.hidden) {
      this.removeAttribute('aria-label');
      return;
    }

    this.setAttribute('aria-label', `${this.dataset.discountLabel}: ${value}%`);
  }
}

if (!customElements.get('discount-percentage')) {
  customElements.define('discount-percentage', DiscountPercentage);
}
